import { observer } from 'mobx-react-lite';
import { UnitQueueRowData } from '../../../socket/stream-types';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { Icon, Box } from '@cad-arc';
import { agencyTypeIconNames } from '../../../common/helpers/agency-type';
import { AgencyTypeGlobal } from '../../../common/global-attributes';

export const UnitClassIconCell = observer(function UnitClassIconCell({
    data,
}: {
    data: UnitQueueRowData;
}): React.ReactElement {
    const iconName = agencyTypeIconNames[data.agencyTypeGlobalAttrId as AgencyTypeGlobal];
    return (
        <BaseQueueCell alignment="CENTER">
            {iconName && (
                <Box position="relative" top={-0.7}>
                    <Icon icon={iconName} size="sm" color="icon.default" />
                </Box>
            )}
        </BaseQueueCell>
    );
});
